<template>
    <el-form ref="dcsForm"
             :model="form"
             :rules="rules"
             class="dcs-form-wrapper">
    <div class="dcs-form page">
        <!-- === TWO-COLUMN LAYOUT: LEFT BRAND / RIGHT CONTENT === -->
        <div class="two-col">
            <!-- LEFT: logo + stacked brand text -->
            <div class="col-left">
                <img class="brand-logo" src="static/dcs_logo.png" alt="DCS logo">
            </div>

            <!-- RIGHT: WORK ORDER label + box -->
            <div class="col-right">
                <div class="wo-label">WORK ORDER</div>

                <!-- === TOP INFO BOX (2 rows, bold borders) === -->
                <div class="wo-box">
                    <div class="row">
                        <div class="cell left">
                            <label>WORK ORDER #:</label>
                            <el-input v-model="form.workOrderNo" size="mini" class="bare" disabled/>
                        </div>
                        <div class="cell right">
                            <label>DATE (YY/MM/DD):</label>
                            <el-date-picker v-model="form.date" size="mini" type="date" value-format="yyyy-MM-dd" format="yy/MM/dd" class="bare" disabled/>
                        </div>
                    </div>
                    <div class="row single">
                        <div class="cell full">
                            <label>TECHNICIAN #:</label>
                            <el-form-item prop="technicianNo" class="compact-form-item">
                                <el-input v-model="form.technicianNo" size="mini" class="bare" />
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="equip-box">
                    <div class="row head">
                        <div class="cell full checks">
                            <el-checkbox disabled v-model="form.flags.warranty" class="tiny">WARRANTY</el-checkbox>
                            <el-checkbox disabled v-model="form.flags.nonWarranty" class="tiny">NON WARRANTY</el-checkbox>
                            <el-checkbox disabled v-model="form.flags.callBack" class="tiny">CALL BACK</el-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="cell half">
                            <label>MODEL:</label>
                            <product-selector v-model="form.equipment.model1" disabled></product-selector>
                            
                        </div>
                        <div class="cell half left-divider">
                            <label>MODEL:</label>
                            <el-input v-model="form.equipment.model2" size="mini" class="bare" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="cell half">
                            <label>SERIAL #:</label>
                            <el-input v-model="form.equipment.serial1" size="mini" class="bare" disabled/>
                        </div>
                        <div class="cell half left-divider">
                            <label>SERIAL #:</label>
                            <el-input v-model="form.equipment.serial2" size="mini" class="bare" />
                        </div>
                    </div>
                    <div class="row single">
                        <div class="cell full">
                            <label>MANUFACTURER:</label>
                            <el-input v-model="form.equipment.manufacturer" size="mini" class="bare" />
                        </div>
                    </div>
                </div>


            </div>
        </div>
        <div class="site-sr-box">
            <div class="hdr">
                <div class="hdr-left">SITE INFORMATION</div>
                <div class="hdr-right">SERVICE REQUEST DETAILS</div>
            </div>
            <div class="grid">
                <!-- Left column rows -->
                <!--<div class="cell l-full">
        <label>NAME:</label>
        <el-input v-model="form.site.name" size="mini" class="bare" />
    </div>

    <!-- Right column big notes (rowspan) -->
                <div class="cell r-notes">
                    <label>COMPLAINT NOTES:</label>
                    <el-form-item prop="request.complaintNotes" class="compact-form-item">
                        <el-input type="textarea" :rows="8" v-model="form.request.complaintNotes" class="bare" />
                    </el-form-item>
                </div>

                <div class="cell l-full">
                    <label>STORE #:</label>
                    <el-form-item prop="site.storeNo" class="compact-form-item">
                        <customer-selector v-model="form.site.storeNo"
                                           ref="customerIdSelector"></customer-selector>
                    </el-form-item>
                </div>

                <!--<div class="cell l-full">
        <label>STREET:</label>
        <el-input v-model="form.site.street" size="mini" class="bare" />
    </div>

    <div class="cell l-full">
        <div class="pair">
            <div class="pair-item">
                <label>CITY:</label>
                <el-input v-model="form.site.city" size="mini" class="bare" />
            </div>
            <div class="pair-item left-divider">
                <label>ZIP:</label>
                <el-input v-model="form.site.zip" size="mini" class="bare" />
            </div>
        </div>
    </div>

    <div class="cell l-full">
        <div class="pair">
            <div class="pair-item">
                <label>PHONE:</label>
                <el-input v-model="form.site.phone" size="mini" class="bare" />
            </div>
            <div class="pair-item left-divider">
                <label>CONTACT:</label>
                <el-input v-model="form.site.contact" size="mini" class="bare" />
            </div>
        </div>
    </div>-->
                <!-- fuel row: left blank, right shows fuel options -->
                <div class="cell blank"></div>
                <div class="cell fuel">
                    <label>TYPE OF FUEL:</label>
                    <el-checkbox v-model="form.request.fuelGas" class="tiny">GAS</el-checkbox>
                    <el-checkbox v-model="form.request.fuelPropane" class="tiny">PROPANE</el-checkbox>
                </div>
            </div>
        </div>
        <div class="desc-box">
            <div class="band">DESCRIPTION OF WORK PERFORMED</div>
            <div class="desc-area">
                <el-form-item prop="work.description" class="compact-form-item">
                    <el-input type="textarea" :rows="6" v-model="form.work.description" class="bare" />
                </el-form-item>
            </div>

            <div class="band split">
                <div>PARTS/MATERIALS/EQUIPMENT USED</div>
                <div>RECOMMENDATIONS/ADDITIONAL FINDINGS</div>
            </div>
            <div class="parts-rec">
                <div class="parts-left">
                    <div class="row small-head">
                        <div class="cell">PART #:</div>
                        <div class="cell qty">QTY:</div>
                    </div>
                    <div class="row" v-for="(r,i) in form.partsRows" :key="i">
                        <div class="cell">
                            <claim-part-selector
                                ref="part-selector"
                                :value="r.part1"
                                :selected-part-data="r.partData"
                                :serviceCompanyId="normalizedServiceCompanyId"
                                :productId="normalizedProductId"
                                @input="updatePartRowSelection(i, $event)"
                                @part-selected="part => updatePartRowPart(i, part)"></claim-part-selector>
                        </div>
                        <div class="cell qty"><el-input v-model="r.qty1" size="mini" class="bare" /></div>
                    </div>
                </div>
                <div class="rec-right">
                    <el-input type="textarea" :rows="5" v-model="form.work.recommendations" class="bare" />
                </div>
            </div>
        </div>

        <!-- === HOURS / TRAVEL / MILEAGE TABLE === -->
        <el-form-item prop="workEntries" class="table-form-item">
        <div class="hours-box">
            <div class="hours-table">
                <div class="hr-row head">
                    <div class="cell">DATE<br>(YY/MM/DD)</div>
                    <div class="cell">TRAVEL 1<br>(R/OT)</div>
                    <div class="cell">MILEAGE 1<br>(R/OT)</div>
                    <div class="cell">LABOR TIME IN</div>
                    <div class="cell">LABOR HRS<br>(R/OT)</div>
                    <div class="cell">LABOR TIME OUT</div>
                    <div class="cell">TRAVEL 2<br>(R/OT)</div>
                    <div class="cell">MILEAGE 2<br>(R/OT)</div>
                    <div class="cell">TOTAL<br>(L+T+M)</div>
                </div>
                <div class="hr-row" v-for="(e,i) in form.workEntries" :key="i">
                    <div class="cell"><el-date-picker v-model="e.date" type="date" size="mini" class="bare" value-format="yyyy-MM-dd" format="yy/MM/dd" /></div>
                    <div class="cell"><el-input v-model="e.travel1" size="mini" class="bare" /></div>
                    <div class="cell"><el-input v-model="e.mileage1" size="mini" class="bare" /></div>
                    <div class="cell"><el-input v-model="e.timeIn" size="mini" class="bare" placeholder="HH:MM" /></div>
                    <div class="cell"><el-input v-model="e.laborHrs" size="mini" class="bare" /></div>
                    <div class="cell"><el-input v-model="e.timeOut" size="mini" class="bare" placeholder="HH:MM" /></div>
                    <div class="cell"><el-input v-model="e.travel2" size="mini" class="bare" /></div>
                    <div class="cell"><el-input v-model="e.mileage2" size="mini" class="bare" /></div>
                    <div class="cell"><el-input v-model="e.total" size="mini" class="bare" readonly /></div>
                </div>
            </div>
        </div>
        </el-form-item>
        <div class="sign-box">
            <div class="sign-row">
                <div class="cell">
                    <label>CUSTOMER NAME:</label>
                    <el-form-item prop="sign.customerName" class="compact-form-item">
                        <el-input v-model="form.sign.customerName" size="mini" class="bare" />
                    </el-form-item>
                </div>
                <div class="cell left-divider">
                    <label>CUSTOMER TITLE:</label>
                    <el-form-item prop="sign.customerTitle" class="compact-form-item">
                        <el-input v-model="form.sign.customerTitle" size="mini" class="bare" />
                    </el-form-item>
                </div>
            </div>
            <div class="sign-row last">
                <div class="cell sig-cell">
                    <label>CUSTOMER SIGNATURE:</label>
                    <el-form-item prop="sign.signature" class="compact-form-item signature-form-item">
                        <div class="sig-box">
                            <canvas ref="custSig"
                                    :width="canvasW"
                                    :height="canvasH"
                                    @mousedown="startDraw($event)"
                                    @mousemove="draw($event)"
                                    @mouseup="stopDraw"
                                    @mouseleave="stopDraw"
                                    @touchstart.prevent="tStart($event)"
                                    @touchmove.prevent="tMove($event)"
                                    @touchend.prevent="stopDraw"></canvas>
                        </div>
                        <div class="sig-actions">
                            <el-button size="mini" @click="clearSig">Clear</el-button>
                        </div>
                    </el-form-item>
                </div>
                <div class="cell left-divider">
                    <label>DATE (YY/MM/DD):</label>
                    <el-form-item prop="sign.date" class="compact-form-item">
                        <el-date-picker v-model="form.sign.date" type="date" size="mini" class="bare" value-format="yyyy-MM-dd" format="yy/MM/dd" />
                    </el-form-item>
                </div>
            </div>
        </div>
    </div>
    </el-form>
</template>

<script>
    import {
        CustomerSelector,
        ServiceTicketSelector,
        ProductSelector,
        ServiceCoverageSelector,
        AttnSelector
    } from "@/app/shared/components";
    import ClaimPartSelector from "./ClaimPartSelector";
    export default {
        name: 'DcsWorkOrderForm',
        props: {
            value: { type: Object, default: null },
            generalInfo: { type: Object, default: null },
            siteInfo: { type: Object, default: null },
            logoSrc: { type: String, default: 'static/dcs_logo.png' },
            serviceCompanyId: { type: [Number, String], default: null }
        },
        data() {
            return {
                canvasW: 700,
                canvasH: 120,
                drawing: false,
                lastPoint: null,
                syncingFromParent: false,
                form: this.normalizeForm(this.value),
            }
        },
        computed: {
            normalizedServiceCompanyId() {
                const parsed = Number(this.serviceCompanyId)
                return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined
            },
            normalizedProductId() {
                const parsed = Number(this.form.equipment.model1)
                return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined
            },
            rules() {
                return {
                    technicianNo: [{ required: true, message: 'Technician number is required.', trigger: 'blur' }],
                    'site.storeNo': [{ required: true, message: 'Store number is required.', trigger: 'change' }],
                    'request.complaintNotes': [{ required: true, message: 'Complaint notes are required.', trigger: 'blur' }],
                    workEntries: [{ validator: this.validateWorkEntries, trigger: 'change' }],
                    'sign.customerName': [{ required: true, message: 'Customer name is required.', trigger: 'blur' }],
                    'sign.customerTitle': [{ required: true, message: 'Customer title is required.', trigger: 'blur' }],
                    'sign.date': [{ validator: this.validateSignDate, trigger: 'change' }],
                    'sign.signature': [{ validator: this.validateSignature, trigger: 'change' }]
                }
            }
        },
        components: {
            CustomerSelector,
            ProductSelector,
            ServiceCoverageSelector,
            ServiceTicketSelector,
            AttnSelector,
            ClaimPartSelector
        },
        watch: {
            value: {
                immediate: true,
                deep: true,
                handler(val) {
                    const normalized = this.normalizeForm(val)
                    if (this.formsMatch(normalized, this.form)) return
                    this.syncingFromParent = true
                    this.form = normalized
                    this.$nextTick(() => {
                        this.applyClaimContext()
                        this.updateWorkEntryTotals()
                        this.syncingFromParent = false
                    })
                }
            },
            generalInfo: {
                immediate: true,
                deep: true,
                handler() { this.applyClaimContext() }
            },
            siteInfo: {
                immediate: true,
                deep: true,
                handler() { this.applyClaimContext() }
            },
            form: {
                deep: true,
                handler(val) {
                    if (this.syncingFromParent) return
                    this.$emit('input', this.cloneForm(val))
                }
            },
            'form.workEntries': {
                deep: true,
                handler() { this.updateWorkEntryTotals() }
            }
        },
        mounted() {
            this.applyClaimContext()
            this.updateWorkEntryTotals()
            this.$emit('input', this.cloneForm(this.form))
        },
        methods: {
            normalizeForm(value) {
                const empty = this.emptyForm()
                const source = value || {}
                const emptyPartRow = empty.partsRows[0]
                const emptyWorkEntry = empty.workEntries[0]

                return {
                    ...empty,
                    ...source,
                    flags: { ...empty.flags, ...(source.flags || {}) },
                    equipment: { ...empty.equipment, ...(source.equipment || {}) },
                    site: { ...empty.site, ...(source.site || {}) },
                    request: { ...empty.request, ...(source.request || {}) },
                    work: { ...empty.work, ...(source.work || {}) },
                    partsRows: Array.isArray(source.partsRows) && source.partsRows.length
                        ? source.partsRows.map(row => ({ ...emptyPartRow, ...row }))
                        : empty.partsRows,
                    workEntries: Array.isArray(source.workEntries) && source.workEntries.length
                        ? source.workEntries.map(entry => ({ ...emptyWorkEntry, ...entry }))
                        : empty.workEntries,
                    sign: { ...empty.sign, ...(source.sign || {}) }
                }
            },
            cloneForm(value) {
                return JSON.parse(JSON.stringify(this.normalizeForm(value)))
            },
            formsMatch(left, right) {
                return JSON.stringify(this.normalizeForm(left)) === JSON.stringify(this.normalizeForm(right))
            },
            formatDate(value) {
                if (!value) return ''
                if (typeof value === 'string') return value.slice(0, 10)
                if (value instanceof Date && !isNaN(value.getTime())) {
                    const month = `${value.getMonth() + 1}`.padStart(2, '0')
                    const day = `${value.getDate()}`.padStart(2, '0')
                    return `${value.getFullYear()}-${month}-${day}`
                }
                return ''
            },
            applyClaimContext() {
                try {
                    const g = (this.generalInfo && (this.generalInfo.generalForm || this.generalInfo.general || this.generalInfo)) || {}
                    const site = this.siteInfo || {}
                    this.form.workOrderNo = g.serviceWorkOrder || g.workOrderNo || this.form.workOrderNo
                    this.form.date = this.formatDate(g.dateWorkCompleted || g.dateOfDispatch || g.date || this.form.date)

                    if (typeof g.is90DaysWarranty === 'boolean') this.form.flags.warranty = g.is90DaysWarranty
                    if (g.serviceCoverage !== undefined && g.serviceCoverage !== null && g.serviceCoverage !== '') {
                        const coverage = parseInt(g.serviceCoverage, 10)
                        this.form.flags.nonWarranty = [2, 3, 4, 8].includes(coverage)
                    }

                    this.form.equipment.model1 = g.productId
                    this.form.equipment.serial1 = g.serialNumber || this.form.equipment.serial1
                    this.form.equipment.manufacturer = g.manufacturer || this.form.equipment.manufacturer

                    if ((this.form.site.storeNo === '' || this.form.site.storeNo === null || typeof this.form.site.storeNo === 'undefined') &&
                        site.customerId !== undefined && site.customerId !== null && site.customerId !== '') {
                        this.form.site.storeNo = site.customerId
                    }
                    if (site.complaint && this.form.request.complaintNotes !== site.complaint) {
                        this.form.request.complaintNotes = site.complaint
                    }
                    if (!this.form.technicianNo && site.technicianName) {
                        this.form.technicianNo = site.technicianName
                    }
                    if (!this.form.sign.customerName && site.orderSignedBy) {
                        this.form.sign.customerName = site.orderSignedBy
                    }
                } catch (e) {
                    // best-effort
                }
            },
            emptyForm() {
                const today = new Date().toISOString().slice(0, 10)
                return {
                    workOrderNo: '',
                    date: today,
                    technicianNo: '',
                    flags: { warranty: false, nonWarranty: false, callBack: false },
                    equipment: { model1: '', model2: '', serial1: '', serial2: '', manufacturer: '' },
                    site: { name: '', storeNo: '', street: '', city: '', zip: '', phone: '', contact: '' },
                    request: { complaintNotes: '', fuelGas: false, fuelPropane: false },
                    work: { description: '', recommendations: '' },
                    partsRows: [{ part1: '', partData: null, qty1: '', part2: '', qty2: '' }, { part1: '', partData: null, qty1: '', part2: '', qty2: '' }, { part1: '', partData: null, qty1: '', part2: '', qty2: '' }],
                    workEntries: Array.from({ length: 5 }, () => ({ date: '', travel1: '', mileage1: '', timeIn: '', laborHrs: '', timeOut: '', travel2: '', mileage2: '', total: '' })),
                    sign: { customerName: '', customerTitle: '', date: today, signature: null }
                }
            },
            updatePartRowSelection(index, value) {
                this.$set(this.form.partsRows[index], 'part1', value || '')
                if (!value) {
                    this.$set(this.form.partsRows[index], 'partData', null)
                }
            },
            updatePartRowPart(index, part) {
                this.$set(this.form.partsRows[index], 'partData', part || null)
                this.$set(this.form.partsRows[index], 'part1', part && part.id ? part.id : '')
            },
            parseNumber(value) {
                const parsed = Number(value)
                return Number.isFinite(parsed) ? parsed : 0
            },
            isNonNegativeNumber(value) {
                if (value === '' || value === null || typeof value === 'undefined') return true
                return /^(\d+(\.\d+)?)$/.test(String(value))
            },
            hasWorkEntryValue(entry) {
                return ['date', 'travel1', 'mileage1', 'timeIn', 'laborHrs', 'timeOut', 'travel2', 'mileage2']
                    .some(key => entry[key] !== '' && entry[key] !== null && typeof entry[key] !== 'undefined')
            },
            updateWorkEntryTotals() {
                const rows = Array.isArray(this.form.workEntries) ? this.form.workEntries : []
                rows.forEach((entry, index) => {
                    const total = this.parseNumber(entry.travel1) +
                        this.parseNumber(entry.mileage1) +
                        this.parseNumber(entry.laborHrs) +
                        this.parseNumber(entry.travel2) +
                        this.parseNumber(entry.mileage2)
                    const totalValue = total > 0 ? `${total}` : ''
                    if (entry.total !== totalValue) {
                        this.$set(this.form.workEntries[index], 'total', totalValue)
                    }
                })
            },
            validateWorkEntries(rule, value, callback) {
                const timePattern = /^([01]\d|2[0-3]):[0-5]\d$/
                const rows = Array.isArray(value) ? value : []
                for (let i = 0; i < rows.length; i += 1) {
                    const entry = rows[i]
                    if (!this.hasWorkEntryValue(entry)) continue

                    const numericFields = ['travel1', 'mileage1', 'laborHrs', 'travel2', 'mileage2']
                    for (let j = 0; j < numericFields.length; j += 1) {
                        const field = numericFields[j]
                        if (!this.isNonNegativeNumber(entry[field])) {
                            callback(new Error(`Row ${i + 1} has an invalid ${field} value.`))
                            return
                        }
                    }

                    if (entry.timeIn && !timePattern.test(entry.timeIn)) {
                        callback(new Error(`Row ${i + 1} labor time in must be HH:MM.`))
                        return
                    }
                    if (entry.timeOut && !timePattern.test(entry.timeOut)) {
                        callback(new Error(`Row ${i + 1} labor time out must be HH:MM.`))
                        return
                    }
                }

                callback()
            },
            validateSignDate(rule, value, callback) {
                if (!value) {
                    callback(new Error('Signature date is required.'))
                    return
                }
                callback()
            },
            validateSignature(rule, value, callback) {
                if (!value) {
                    callback(new Error('Customer signature is required.'))
                    return
                }
                callback()
            },
            validate() {
                return new Promise(resolve => {
                    if (!this.$refs.dcsForm) {
                        resolve(true)
                        return
                    }
                    this.$refs.dcsForm.validate(valid => resolve(valid))
                })
            },
            ctx() { const c = this.$refs.custSig; return c ? c.getContext('2d') : null },
            _relPos(clientX, clientY) { const rect = this.$refs.custSig.getBoundingClientRect(); return { x: clientX - rect.left, y: clientY - rect.top } },
            startDraw(evt) { this.drawing = true; const p = this._relPos(evt.clientX, evt.clientY); this.lastPoint = p },
            draw(evt) { if (!this.drawing) return; const ctx = this.ctx(); if (!ctx) return; ctx.lineWidth = 2; ctx.lineCap = 'round'; const p = this._relPos(evt.clientX, evt.clientY); ctx.beginPath(); ctx.moveTo(this.lastPoint.x, this.lastPoint.y); ctx.lineTo(p.x, p.y); ctx.stroke(); this.lastPoint = p },
            stopDraw() {
                if (!this.drawing) return
                this.drawing = false
                this.lastPoint = null
                const c = this.$refs.custSig
                this.form.sign.signature = c.toDataURL('image/png')
                if (this.$refs.dcsForm) this.$refs.dcsForm.validateField('sign.signature')
            },
            clearSig() {
                const ctx = this.ctx()
                if (!ctx) return
                ctx.clearRect(0, 0, this.canvasW, this.canvasH)
                this.form.sign.signature = null
                if (this.$refs.dcsForm) this.$refs.dcsForm.validateField('sign.signature')
            },
            // touch helpers
            tStart(e) { const t = e.touches[0]; this.drawing = true; this.lastPoint = this._relPos(t.clientX, t.clientY) },
            tMove(e) { if (!this.drawing) return; const t = e.touches[0]; const ctx = this.ctx(); if (!ctx) return; ctx.lineWidth = 2; ctx.lineCap = 'round'; const p = this._relPos(t.clientX, t.clientY); ctx.beginPath(); ctx.moveTo(this.lastPoint.x, this.lastPoint.y); ctx.lineTo(p.x, p.y); ctx.stroke(); this.lastPoint = p },
        }
    }
</script>

<style scoped>
    .compact-form-item,
    .table-form-item {
        margin-bottom: 0;
        width: 100%;
    }

    .compact-form-item :deep(.el-form-item__content),
    .table-form-item :deep(.el-form-item__content) {
        margin-left: 0 !important;
        line-height: normal;
    }

    .signature-form-item :deep(.el-form-item__error) {
        position: static;
        padding-top: 6px;
    }

    /* page width close to Letter content area */
    .page {
        max-width: 900px;
        width: 900px;
        margin: 0 auto;
    }

    /* === GRID so the right column never slides under the logo === */
    .two-col {
        display: grid;
        grid-template-columns: 260px 1fr;
        gap: 16px;
        align-items: start;
    }

    .col-left {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .brand-logo {
        width: 250px;
        height: auto;
        display: block;
    }

    .brand-text {
        margin-top: 8px;
        line-height: 1.05;
        font-weight: 700;
        letter-spacing: 0.4px;
    }

        .brand-text div {
            text-transform: uppercase;
        }

    .col-right {
        display: flex;
        flex-direction: column;
    }

    .wo-label {
        align-self: flex-end;
        font-weight: 800;
        font-style: italic;
        font-size: 28px;
        letter-spacing: 0.5px;
        margin-bottom: 6px;
    }

    /* ==== TOP INFO BOX ==== */
    .wo-box {
        border: 2px solid #000;
    }

    .row {
        display: flex;
        border-bottom: 2px solid #000;
    }

        .row.single {
            border-bottom: 0;
        }

    .cell {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 8px;
    }

        .cell.left {
            width: 65%;
            border-right: 2px solid #000;
        }

        .cell.right {
            width: 35%;
        }

        .cell.full {
            width: 100%;
        }

    label {
        font-weight: 700;
        font-size: 13px;
        letter-spacing: 0.3px;
    }

    /* remove element-ui chrome inside this box */
    .bare :deep(.el-input__inner),
    .bare :deep(.el-date-editor .el-input__inner) {
        border: none;
        box-shadow: none;
        padding-left: 4px;
        height: 26px;
        font-weight: 700;
        font-size: 14px;
    }

    .bare :deep(.el-input__inner:focus) {
        box-shadow: none;
    }

    .bare :deep(.el-input__prefix),
    .bare :deep(.el-input__suffix) {
        display: none;
    }

    /* tighten date editor */
    :deep(.el-date-editor--date) {
        width: 160px;
    }
    /* === EQUIPMENT BOX styles === */
    .equip-box {
        border: 2px solid #000;
        margin-top: 10px;
    }

        .equip-box .row {
            display: flex;
            border-bottom: 2px solid #000;
        }

            .equip-box .row.single {
                border-bottom: 0;
            }

        .equip-box .cell {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 6px 8px;
        }

            .equip-box .cell.half {
                width: 50%;
            }

        .equip-box .left-divider {
            border-left: 2px solid #000;
        }

        .equip-box .checks {
            gap: 24px;
        }

    /* checkbox look like PDF */
    .tiny :deep(.el-checkbox__label) {
        font-weight: 700;
        font-size: 13px;
        letter-spacing: 0.3px;
        padding-left: 6px;
    }

    .tiny :deep(.el-checkbox__inner) {
        width: 14px;
        height: 14px;
        border: 2px solid #000;
    }

    .tiny :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
        background-color: #000;
        border-color: #000;
    }

    .tiny :deep(.el-checkbox__inner::after) {
        border-color: #fff;
    }

    .site-sr-box {
        margin-top: 12px;
    }

        .site-sr-box .hdr {
            display: grid;
            grid-template-columns: 1fr 1fr;
            background: #000;
            color: #fff;
            font-weight: 800;
            letter-spacing: .4px;
        }

        .site-sr-box .hdr-left, .site-sr-box .hdr-right {
            text-align: left !important;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border: 2px solid #000;
            border-bottom: none;
        }

        .site-sr-box .hdr-left {
            border-right: none;
        }

        .site-sr-box .hdr-right {
            border-left: none;
        }

        .site-sr-box .grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            border: 2px solid #000;
            border-top: none;
        }

            .site-sr-box .grid .cell {
                border-bottom: 2px solid #000;
                padding: 6px 8px;
                display: flex;
                align-items: center;
                gap: 8px;
            }

                .site-sr-box .grid .cell.blank {
                    border-bottom: 0;
                }

            .site-sr-box .grid .fuel {
                justify-content: flex-start;
                gap: 18px;
            }

            .site-sr-box .grid .r-notes {
                grid-column: 2/3;
                grid-row: 1/span 5;
                align-items: flex-start;
                flex-direction: column;
            }

            .site-sr-box .grid .l-full {
                grid-column: 1/2;
            }

            .site-sr-box .grid .pair {
                display: flex;
                width: 100%;
            }

            .site-sr-box .grid .pair-item {
                flex: 1;
                display: flex;
                align-items: center;
                gap: 8px;
                padding-right: 8px;
            }

                .site-sr-box .grid .pair-item.left-divider {
                    border-left: 2px solid #000;
                    padding-left: 8px;
                }
    /* === DESCRIPTION / PARTS / RECOMMENDATIONS === */
    .desc-box .band {
        background: #000;
        color: #fff;
        font-weight: 800;
        letter-spacing: .4px;
        padding: 6px 8px;
        border: 2px solid #000;
        border-bottom: none;
        text-align: center;
    }

        .desc-box .band.split {
            display: grid;
            grid-template-columns: 2fr 3fr;
            text-align: center;
        }

    .desc-box .desc-area {
        border: 2px solid #000;
        border-top: none;
        padding: 6px 8px;
    }

    .parts-rec {
        border: 2px solid #000;
        border-top: none;
        display: grid;
        grid-template-columns: 2fr 3fr;
    }

    .parts-left {
        border-right: 2px solid #000;
    }

        .parts-left .row {
            display: grid;
            grid-template-columns: 3.2fr 0.6fr;
            border-bottom: 2px solid #000;
        }

            .parts-left .row:last-child {
                border-bottom: 0;
            }

        .parts-left .cell {
            padding: 6px 8px;
            border-right: 2px solid #000;
            display: flex;
            align-items: center;
        }

            .parts-left .cell.qty {
                width: auto;
                min-width: 72px;
            }

            .parts-left .cell:last-child {
                border-right: 0;
            }

    .rec-right {
        padding: 6px 8px;
    }

    /* === HOURS TABLE === */
    .hours-box {
        margin-top: 10px;
    }

    .hours-table {
        border: 2px solid #000;
    }

    .hr-row {
        display: grid;
        grid-template-columns: 3.2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        border-bottom: 2px solid #000;
    }

        .hr-row:last-child {
            border-bottom: 0;
        }

        .hr-row .cell {
            border-right: 2px solid #000;
            padding: 6px 8px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            text-align: left;
        }

            .hr-row .cell:last-child {
                border-right: 0;
            }

        .hr-row.head {
            background: #000;
            color: #fff;
            font-weight: 800;
            letter-spacing: .3px;
        }
    /* === SIGNATURES BOX === */
    .sign-box {
        border: 2px solid #000;
        margin-top: 10px;
    }

    .sign-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        border-bottom: 2px solid #000;
    }

        .sign-row.last {
            border-bottom: 0;
        }

        .sign-row .cell {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 6px 8px;
        }

            .sign-row .cell.left-divider {
                border-left: 2px solid #000;
            }

    .sig-box {
        border: 1px dashed #9e9e9e;
        background: #fff;
        width: 100%;
        height: 110px;
    }

        .sig-box canvas {
            width: 100%;
            height: 100%;
            display: block;
        }

    .sig-actions {
        margin-top: 6px;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/claims/components/DcsWorkOrderForm.vue